const wrapper = "_35swnnbw3m";
const container = "_35scyupf6a";

export { container, wrapper };
import "./_task.mark-characters.style.linaria.module.css";
//# sourceMappingURL=_task.mark-characters.style.js.map
